import axiosClient from './axiosClient';

const publicApi = {
  /**
   * Gửi dữ liệu employee mới từ form public (token xác thực)
   * @param params { token: string, data: any }
   */
  submitEmployeeData: (params: { token: string; data: any }) => {
    // Chuẩn endpoint: POST /public/onboard/fill-data, body: { token, data }
    return axiosClient.post('/public/onboard/fill-data', params);
  },
  verifyToken: (token: string) => {
    // Chuẩn endpoint: POST /public/onboard/verify-token, body: { token }
    return axiosClient.post(`/public/onboard/verify-token`, { token });
  },
};

export default publicApi;
